import Community from "components/Community/Community"

const CommunityPanel = () => {
  return (
    <Community />
  )
}

export default CommunityPanel;
